import { Observable } from 'rxjs';
import { GuardChecker } from './guard-checker-interface';
import { BetaGuard } from "../guards/beta.guard";

export class BetaGuardChecker implements GuardChecker {
  check(guard: BetaGuard): Observable<boolean> {
    return guard.hasBetaRole();
  }
}
